export function formattedGameCode (code) {
  if (!code) {
    return null
  }

  const stringCode = String(code)

  return stringCode.replace(/(\d{3})(\d{3})/, '$1 $2')
}
